import styled from 'styled-components';
import { InfoBanner, WarningBanner } from 'ui/banner';
import { ButtonGroup } from 'ui/buttonGroup';
import { Link } from 'ui/links';
import TableRows from 'ui/tableRows/TableRows';
import TableHeader from 'ui/tableHeader/TableHeader';
import { spacing, body1, colors, smallShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledBanner = styled(InfoBanner)`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledWarningInfoBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledLink = styled(Link)`
  color: inherit;
  text-decoration-color: inherit;
`;

export const SelectWrapper = styled.div`
  flex: 1;
`;

export const SegmentControls = styled.div`
  display: flex;
  padding: ${spacing.base} ${spacing.plusHalf};
  background: ${colors.white};
  border-bottom: ${spacing.single} solid ${colors.grey15};
  gap: ${spacing.half};
  justify-content: space-between;
`;

export const ButtonGroupWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ExportWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledButtonGroup = styled(ButtonGroup)<{ background?: string }>`
  ${body1}
  margin-left: ${spacing.base};
`;

export const SegmentCard = styled.div`
  ${smallShadow};
  border-radius: ${spacing.half};
  overflow: hidden;
`;

export const SegmentBody = styled.div`
  border-top: none;
  > div {
    margin-right: 0;
  }
`;

export const TableWrapper = styled.div`
  max-height: 60vh;
  overflow: auto;
  margin-right: ${spacing.base};
`;

export const StyledHeader = styled(TableHeader)`
  > div:first-child {
    position: sticky;
    left: 0;
    width: ${pxToRem(256)};
    background: ${colors.white};
    box-shadow: inset -${spacing.quarter} ${spacing.single} ${spacing.half} -${pxToRem(6)}
      rgba(0, 0, 0, 0.12);
    padding-left: ${spacing.base};
    padding-right: ${spacing.x4};
    vertical-align: middle;
    z-index: 2;
  }
  > div {
    height: ${spacing.x3};
    padding-left: ${spacing.double};
    vertical-align: middle;
    border-bottom: ${colors.grey15} ${spacing.single} solid;
  }
  > div > div > svg {
    margin-left: ${spacing.quarter};
  }
`;

export const StyledRows = styled(TableRows)`
  height: ${spacing.x3};
  border-bottom: ${spacing.single} solid ${colors.grey15};
  > div:first-child {
    position: sticky;
    left: 0;
    align-items: center;
    width: ${pxToRem(256)};
    background: inherit;
    border-bottom: ${spacing.single} solid ${colors.grey15};
    padding-left: ${spacing.base};
    box-shadow: inset -${spacing.quarter} ${spacing.single} ${spacing.half} -${pxToRem(6)}
      rgba(0, 0, 0, 0.12);
  }
`;

export const MediumCircle = styled.div`
  display: inline-block;
  width: ${spacing.half};
  height: ${spacing.half};
  background: ${({ color }) => color || colors.grey15};
  border-radius: 50%;
  margin-right: ${spacing.half};
  margin-bottom: ${spacing.single};
`;
